<div class="support-hub-container">
  <div *ngFor="let panel of panels; let i = index" class="panel-wrapper panel-spacing">
    <si-collapsible-panel contentCssClasses="p-6" [opened]="i === 0">
      <div si-panel-heading class="custom-panel-heading">
        <span class="panel-title" [siTooltip]="panel.title" placement="bottom"><span class="panel-title-text">{{ panel.title }}</span></span>
        <span class="panel-timestamp">{{ getPanelTimestamp(panel) }}</span>
        <button
          class="panel-copy-btn"
          siTooltip="Copy content"
          placement="bottom"
          (click)="copyPanelContent(panel, $event)">
          <i class="element-copy"></i>
        </button>
      </div>
      <div class="markdown-content" [innerHTML]="getParsedContent(panel.content)"></div>
    </si-collapsible-panel>
  </div>
</div>